import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import DailyStatistics from '../daily-statistics/DailyStatistics';

const ContactosHeader = ({ cargando, vendedor }) => {
    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <img src="/img/cliente96.png" alt="connectCircle" height={30} />
                    </Col>
                    <Col>
                        <h5>Leads</h5>
                    </Col>
                </Row>
                <Row>
                    
                </Row>
            </Card>
            {cargando ? (
                // Placeholder similar in size to DailyStatistics while leads load
                <Card className="mb-2 p-2">
                    <Card.Body>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                            <div className="d-flex align-items-center">
                                <Skeleton width={140} height={18} />
                            </div>
                            <div style={{ width: 140 }}>
                                <Skeleton width={140} height={28} />
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: 12 }}>
                            <Skeleton width={120} height={64} />
                            <Skeleton width={120} height={64} />
                            <Skeleton width={120} height={64} />
                            <Skeleton width={120} height={64} />
                        </div>
                    </Card.Body>
                </Card>
            ) : (
                <DailyStatistics vendedor={vendedor} />
            )}
        </>
    );
};

ContactosHeader.propTypes = {
    cargando: PropTypes.bool.isRequired,
    vendedor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default ContactosHeader;
